<template>
  <section class="content">
    <div v-show="companyDL.is_active ==  null" class="callout callout-warning" id="directSales">
      <p>{{ 'warning_dl_not_active' | translate }}</p></div>
    <div v-show="companyDL.is_active === 0 || companyDL.is_active === 1">
    <template v-if="loading">
      <div class="overlay" v-show="loading">
        <img class="loading-gif" src="/static/img/blabla.svg"/>
      </div>
    </template>
    <div id="directSalesNotAccepted" v-else-if="!termsAccepted">
      <div class="modal-dialog">
        <form class="modal-content">
          <div class="modal-header">
            <h4 id="forgot_ModalLabel" class="modal-title"><i class="fa fa-bullhorn mr-5"></i>{{'notification' | translate}}</h4>
          </div>
          <div class="modal-body">
            <div class="alert alert-danger">
              <h4><i class="icon fa fa-warning"></i> {{'alert_warning'| translate}}!</h4>
              <p v-if="$store.getters.language === 'de'">Um die Direktverkaufsfunktion zu aktivieren, müssen Sie den <a class="" :href="filePath" target="_blank"><strong>Allgemeinen Geschäftsbedingungen</strong></a> zustimmen.</p>
              <p v-else-if="$store.getters.language === 'en'">In order to activate the DirectSale function, you must agree to the <a class="" :href="filePath" target="_blank"><strong>General Terms & Conditions</strong></a></p>
              <p v-else>Para poder activar las funciones de DirectSale, ustede debe aceptar los <a class="" :href="filePath" target="_blank"><strong>Términos y Condiciones</strong></a>.</p>
            </div>
            <label id="acceptLabel">
              <input id="acceptAGB" type="checkbox" v-model="acceptCheck"> {{'i_agree_to_terms' | translate}}.
            </label>
          </div>
          <div class="modal-footer">
            <button v-if="acceptCheck" id="acceptBtn" type="button" class="btn btn-success pull-left" @click="setAcceptedStatus()"><i class="fa fa-check mr-5"></i>{{'agree' | translate}}</button>
            <a href="/" type="button" class="btn btn-outline"><i class="fa fa-times mr-5"></i>{{'cancel' | translate}}</a>
          </div>
        </form>
      </div>
    </div>
    <template v-else>
      <div id="directSalesAccepted" class="callout callout-success">
        <p v-if="$store.getters.language === 'de'">Sie haben den <a class="" :href="filePath" target="_blank">Allgemeinen
          Geschäftsbedingungen</a> zum Direktverkauf am <span>{{ acceptedDate }}</span> zugestimmt.</p>
        <p v-else-if="$store.getters.language === 'en'">
          You have accepted the <a class="" :href="filePath" target="_blank">General Terms & Conditions</a> for DirectSale on <span>{{ acceptedDate }}</span>
        </p>
        <p v-else>
          Usted ha aceptado los <a class="" :href="filePath" target="_blank">Términos & Condiciones</a> de DirectSale el <span>{{ acceptedDate }}</span>
        </p>
      </div>
      <div id="isAccepted" class="row">
        <div class="col-xs-12">
          <div class="nav-tabs-custom no-margin">
            <ul class="nav nav-tabs">
              <li class="active"><a href="#settings" data-toggle="tab" aria-expanded="false">{{'configuration'|translate}}</a></li>
              <li class=""><a href="#stores" data-toggle="tab" aria-expanded="false">{{'stores'|translate}}</a></li>
             </ul>
          </div>
          <div class="tab-content">
            <!-- SETTINGS -->
            <div class="tab-pane active" id="settings">
              <div class="row">
                <div class="col-xs-12">
                  <div class="box box-primary">
                    <div class="box-body">
                      <h5><i class="fa fa-cogs text-muted mr-5"></i>{{'amz_config'|translate}}:</h5>
                      <div class="row">
                        <div class="col-sm-12 col-lg-7">
                          <h4 class="mb-10">{{'basic_settings'| translate}}:</h4>
                          <p>{{'button_to_communicate_with_amazon_auth'|translate}}<br>
                            <span class="text-warning small">{{'eventually_sign_in_amazon_seller_account'| translate}}</span>
                          </p>
                          <a :href="spAuthUrl" class="btn btn-success mb-10" rel="noreferrer">{{ 'create_new_token' | translate }}</a>
                          <div class="form-group">
                            <label>{{ 'token_expiration_date' | translate }}:</label>
                            <input type="text" class="form-control" aria-required="true" aria-invalid="false" v-model="config.merchant_expiration_date" name="merchant_expiration_date">
                          </div>
                          <hr>
                          <h4 class="mb-10">{{ 'amazon_prime_title' | translate }}:</h4>
                          <p>
                            {{'amazon_prime' | translate }}
                            <br>
                            <span class="text-warning small">{{'amazon_prime_benennung' | translate }}</span>
                          </p>
                          <div class="form-group">
                            <label>{{'prime_template' | translate }}: </label>
                            <input type="text" value="" class="form-control" aria-required="true" aria-invalid="false" v-model="config.prime_template" name= "prime_template" v-validate="{regex: /^.{0,100}$/}" >
                            <span v-show="errors.has('prime_template')" class="small text-danger">{{ 'direct_listing_max_200' | translate }}</span>
                          </div>
                          <div class="form-group">
                            <div class="checkbox">
                              <label>
                                <input type="checkbox" v-model="config.force_prime">
                                {{'prime_products' | translate}}
                              </label>
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-12 col-lg-5">
                          <h4>{{'product_lists' | translate}}:</h4>
                          <p>{{'productlists_text' | translate}}</p>
                          <a class="btn btn-success" :href="csvDownloadPath" target="_blank"><i class="fa fa-cloud-download mr-5"></i>Download CSV</a>
                          <hr>
                          <h4 class="mb-10">{{'sales_settings'| translate}}:</h4>
                          <div :class="{'form-group': true, 'has-error': errors.has('Bearbeitungszeit')}">
                            <label>{{'processing_time'| translate}}:</label><br>
                            <p class="small text-muted">{{'shipping_duration'| translate}}</p>
                            <input v-validate="'numeric'" type="text" name="Bearbeitungszeit" v-model="config.processing_time" class="form-control success"
                                   aria-required="true" aria-invalid="false" id="processingTime">
                            <span v-show="errors.has('Bearbeitungszeit')" class="small text-danger">{{ errors.first('Bearbeitungszeit') }}</span>
                          </div>
                          <div :class="{'form-group': true, 'has-error': errors.has('Bestandsminderung')}">
                            <label>{{'inventory_reduction'| translate}}:</label><br>
                            <p class="small text-muted">{{'inventory_value_reduction'| translate}}</p>
                            <input type="text"  v-validate="'numeric'" name="Bestandsminderung" v-model="config.inventory_reduction" class="form-control"
                                   aria-required="true" aria-invalid="false" id="inventoryReduction">
                            <span v-show="errors.has('Bestandsminderung')" class="small text-danger">{{ errors.first('Bestandsminderung') }}</span>
                          </div>
                          <!--   <div :class="{'form-group': true, 'has-error': errors.has('Preisfix')}">
                               <label>{{'fixed_price'| translate}}:</label><br>
                               <p class="small text-muted">{{'fixed_price_reduce'| translate}}</p>
                               <input type="text"  v-validate="'decimal:2'" name="Preisfix" v-model="config.price_fix" class="form-control"
                                      aria-required="true" aria-invalid="false" id="priceFix">
                               <span v-show="errors.has('Preisfix')" class="small text-danger">{{ errors.first('Preisfix') }}</span>
                             </div>
                             <div :class="{'form-group': true, 'has-error': errors.has('Preis%')}">
                               <label>{{'price'| translate}} %:</label><br>
                               <p class="small text-muted">{{'fixed_price_reduce'| translate}}</p>
                               <input type="text" v-validate="'decimal:2'" name="Preis%" v-model="config.price_percentage" class="form-control"
                                      aria-required="true" aria-invalid="false" id="pricePercentage">
                               <span v-show="errors.has('Preis%')" class="small text-danger">{{ errors.first('Preis%') }}</span>
                             </div> -->
                        </div>
                      </div>
                      </div>
                    <div class="box-footer">
                      <div class="form-group">
                        <button :disabled="errors.has('host') || errors.has('prime_template') || errors.has('token') || errors.has('Bearbeitungszeit') || errors.has('Bestandsminderung')" class="btn btn-success pull-right" @click="updateConfigData()"><i
                            class="fa fa-save mr-5"></i>{{'save_settings'|translate}}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- STORES -->
            <div class="tab-pane" id="stores">
              <div class="row">
                <div class="col-xs-12">
                  <div class="box box-primary">
                    <div class="box-body">
                      <h5><i class="fa fa-cogs text-muted mr-5"></i>{{'store_settings' | translate}}:</h5>
                      <p>{{'store_activate' | translate}}<br>
                        <span class="text-warning small">{{'store_active_time'| translate}}</span>
                      </p>
                      <div class="row">
                        <div class="col-xs-12">
                          <b-table :items="stores" :fields="fields">
                            <div slot="cell(status)" slot-scope="data">
                              <div data-toggle="btn-toggle" class="btn-group btn-group-sm" v-if="data.item.synchronised">
                                <button type="button"
                                        :class="['btn btn-success', data.item.status === 'active' ? 'active' : '']"
                                        @click="storeActivation(data.item,'active')"><i
                                    class="fa fa-check mr-5"></i>{{'is_active' | translate}}
                                </button>
                                <button type="button"
                                        :class="['btn btn-danger', data.item.status === 'inactive' ? 'active' : '']"
                                        @click="storeActivation(data.item,'inactive')"><i
                                    class="fa fa-ban mr-5"></i>{{'inactive' | translate}}
                                </button>
                              </div>
                              <div v-else class="text-warning">{{'not_synchronized'|translate}} </div>
                            </div>
                            <div slot="cell(info)" slot-scope="data">
                              <small class="text-muted">{{'wws_store_number'|translate}}:</small><br>{{ data.item.info.wws_store_nr }}<br>
                              <small class="text-muted">GLN:</small><br>{{ data.item.info.gln }}
                            </div>
                            <div slot="cell(address)" slot-scope="data">
                              <small class="text-muted">{{'store_address'|translate}}:</small>
                              <br>
                              {{ data.item.address.name }}
                              <br>
                              {{ `${data.item.address.street} ${data.item.address.street_no}` }}
                              <br>
                              {{ `${data.item.address.zip_code} ${data.item.address.city}` }}
                            </div>
                          </b-table>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-xs-12">
                        </div>
                      </div>
                    </div>
                    <div class="box-footer">
                      <div class="form-group">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    </div>
  </section>
</template>
<script>
export default {
  name: 'AmazonView',
  data () {
    return {
      loading: true,
      csvDownloadPath: '',
      companyDL: {},
      termsAccepted: 0,
      acceptCheck: 0,
      acceptedDate: '',
      filePath: '',
      merchantExpirationDate: '',
      config: {
      },
      amazonStores: [],
      stores: [],
      fields: [
        {key: 'status', label: 'Status'},
        {key: 'info', label: 'Infos'},
        {key: 'address', label: 'Filialadresse'}
      ],
      spAuthUrl: ''
    }
  },
  methods: {
    getAuthUrl () {
      API.get('/accounting/company/authUrl')
        .then(response => {
          console.log(response.data.url)
          this.spAuthUrl = response.data.url
        })
    },
    getStores () {
      API.get('directsales/marketplaces/amazon/stores')
        .then(response => {
          this.stores = response.data
        })
    },
    getConfigData () {
      API.get('directsales/marketplaces/amazon/config')
        .then(response => {
          this.config = response.data
          this.amazonStores = this.config.countries
        })
    },
    updateConfigData () {
      this.$validator.validate()
        .then(result => {
          if (result) {
            if (this.config.processing_time === '') {
              this.config.processing_time = 0
            }
            if (this.config.inventory_reduction === '') {
              this.config.inventory_reduction = 0
            }
            API.put('directsales/marketplaces/amazon/config', this.config)
              .then(response => {
                let alert = {
                  dismiss: 4,
                  type: 'success',
                  message: ``
                }
                this.$store.commit('pushAlert', alert)
                this.getConfigData()
              })
          }
        })
    },
    getDownloadCsvLink () {
      API.get('directsales/products')
        .then(res => {
          this.csvDownloadPath = res.data.url
        })
    },
    updateStoreConfig (store) {
      API.put(`directsales/marketplaces/amazon/stores/${store.id}`, store)
        .then(response => {
          this.getStores()
        })
    },
    updateCountryConfig (store) {
      API.put(`directsales/marketplaces/amazon/countryConfig`, store)
        .then(response => {
          this.getConfigData()
        })
    },
    handleClickEvent (name, val) {
      let data = {country: name, active: val}
      this.updateCountryConfig(data)
    },
    checkIfCompanyIsValidForDirectlisting () {
      API.get('directsales/erp').then(res => {
        this.companyDL = res.data
      })
    },
    storeActivation (store, value) {
      if (store.status === value) {
        return
      }
      store.status = value
      this.updateStoreConfig(store)
    },
    getFilePath () {
      API.get(`directsales/file/amazon/terms`, {})
        .then(res => {
          this.filePath = res.data.path
        })
    },
    getAcceptedStatus () {
      API.get(`directsales/terms/amazon`, {})
        .then(res => {
          this.termsAccepted = res.data.termsAccepted
          this.acceptedDate = res.data.acceptedDate
          this.loading = false
          if (this.termsAccepted === 1) {
            this.getConfigData()
          }
        })
        .catch(error => {
          this.loading = false
        })
    },
    setAcceptedStatus () {
      API.post('directsales/terms/amazon', {termsAccepted: 1})
        .then(response => {
          this.termsAccepted = 1
          this.getConfigData()
          this.getStores()
        })
    }
  },
  mounted() {
    this.checkIfCompanyIsValidForDirectlisting()
    this.getAcceptedStatus()
    this.getFilePath()
    this.getStores()
    this.getDownloadCsvLink()
    this.getAuthUrl()
  }
}
</script>
<style scoped>
.loading-gif {
  top: 25%;
  left: 39%;
  width: 23%;
  position: absolute;
}
</style>



// WEBPACK FOOTER //
// src/components/views/Directsale/AmazonView.vue